import React, { useCallback } from 'react'
import { I18n, hooks } from '@front/volcanion'

import { ModelAutocompleteField } from '@front/squirtle'

import { Grid, Box } from '@mui/material'

const B2BSection = () => {
  const [company, contract] = hooks.useFieldValues(['b2b.company', 'b2b.contract'])

  const autocompleteMutatorB2B = useCallback(q => ({ or: [{ client_id: { startsWith: q } }, { name: { startsWith: q } }] }), [])
  const companyMutator = useCallback(elem => ({ label: `${_.get(elem, 'client_id')} - ${_.get(elem, 'name')}`, ...elem }), [])
  const companyContractMutator = useCallback(elem => ({ label: `${_.get(elem, 'client_id')} - ${_.get(elem, 'name')}`, ...elem }), [])
  const companyServiceMutator = useCallback(elem => ({ label: `${_.get(elem, 'client_id')} - ${_.get(elem, 'name')}`, ...elem }), [])
  const companyContractValidator = useCallback(() => !!company, [company])
  const companyServiceValidator = useCallback(() => !!contract, [contract])

  return (
    <Box flex={1}>
      <Grid container spacing={1}>
        <Grid size={4}>
          <ModelAutocompleteField
            name={'company'}
            label={I18n.t('company.label', { count: 1 })}
            model_name={'company'}
            searchMode='search'
            searchQuery={'startsWith'}
            autocompleteMutator={autocompleteMutatorB2B}
            config={{
              mutator: companyMutator
            }}
          />
        </Grid>
        <Grid size={4}>
          <ModelAutocompleteField
            name={'contract'}
            label={I18n.t('contract.name_client_id')}
            model_name={'companycontract'}
            searchMode='search'
            searchQuery={'startsWith'}
            autocompleteMutator={autocompleteMutatorB2B}
            config={{
              forced_filter: { company },
              validate_filter: companyContractValidator,
              watchers: [company],
              mutator: companyContractMutator
            }}
          />
        </Grid>
        <Grid size={4}>
          <ModelAutocompleteField
            name={'service'}
            label={I18n.t('companyservice.code')}
            model_name={'companyservice'}
            searchMode='search'
            searchQuery={'startsWith'}
            autocompleteMutator={autocompleteMutatorB2B}
            config={{
              forced_filter: { contract },
              validate_filter: companyServiceValidator,
              watchers: [contract],
              mutator: companyServiceMutator
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(B2BSection)
